import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import type { PrayerName } from "@/types/prayer";

interface Props {
  name: PrayerName;
  time: string;
  isNext: boolean;
  isSecondary?: boolean;
  dimmed?: boolean;
}

export function PrayerTimeRow({ name, time, isNext, isSecondary, dimmed }: Props) {
  return (
    <div
      className={cn(
        "flex items-center justify-between py-2.5 px-3 rounded-md transition-colors",
        isNext && "bg-primary/10 font-semibold",
        isSecondary && "text-muted-foreground text-sm",
        dimmed && "text-muted-foreground"
      )}
    >
      <div className="flex items-center gap-2">
        <span>{name}</span>
        {isNext && (
          <Badge variant="secondary" className="text-xs">
            Next
          </Badge>
        )}
      </div>
      <span className="font-mono tabular-nums">{time}</span>
    </div>
  );
}
